define([
  "marionette",
  "jquery",
  "underscore",
  "messaging/messenger",
  "moment",
  "./taskWizardSettingsPageView",
  "modules/tasks/taskUploads/taskUploadsModule",
  "modules/tasks/tasksArea/taskSchedule/taskScheduleModule",
], function (
  Marionette,
  $,
  _,
  Messenger,
  moment,
  TaskWizardSettingsPageView,
  TaskUploadsModule,
  TaskScheduleModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "taskWizardSettingsPage";
      this.isFirstPage = true;
    },
    show: function (task) {
      this.task = task;
      this.view = new TaskWizardSettingsPageView.settingsPageView({ model: this.task });
      this.view.on("change:priority", this._onChangePriority, this);
      this.view.on("change:startDate", this._onChangeStartDate, this);
      this.view.on("create:fromTemplate", this._onCreateFromTemplate, this);
      this.view.on("show", this._onShow, this);

      this.taskUpload = new TaskUploadsModule({
        allowAdd: true,
        allowDelete: true,
        allowUpdate: true,
        region: this.view.upload,
      });
      this.taskSchedule = new TaskScheduleModule({
        region: this.view.schedule,
      });

      // Somehow the way that select2 interacts with the view prevents this from using the loading: true feature
      this.task.taskTemplates.onSynced(() => this.showRegion(this.view));
    },
    commitData: function () {
      const languageIds = this.task.get("languageIds");
      let intentId = this.view.getExistingTopicId();
      if (intentId === null) {
        intentId = this.task.get("intentId");
      }
      const taskUpdate = {
        description: this.view.getTaskDescription(),
        dueDate: this.view.getDueDate(),
        expirationDate: this.taskSchedule.getExpirationDate(),
        intentId: intentId,
        interval: this.taskSchedule.getInterval(),
        intervalAmount: this.taskSchedule.getIntervalAmount(),
        scheduled: this.taskSchedule.isScheduled(),
        languageIds: languageIds,
        name: this.view.getTaskName(),
        notifyEmails: this.view.getNotifyEmails(),
        priority: this.view.getPriority(),
        touchpointIds: this.view.getTouchpointIds(),
      };
      if (this.task.isNew()) {
        // startDate is read only in case of update
        taskUpdate.startDate = this.view.getStartDate();
      }
      this.view.clearErrors();
      this.task.set(taskUpdate);

      let errors = this.task.validate(Object.keys(taskUpdate));

      // it turned out we are not yet ready to move name and description validation into a model
      // it is because there is another add task form on Topic tab
      // adding task on Topic tab does not require task.name and task.decription
      // thus validation in model was failing when creating task from Topic
      if (errors === undefined) {
        errors = {};
      }
      if (!this.task.get("name")) {
        errors["name"] = $.t("commonMessages.emptyMessage");
      }
      if (!this.task.get("description")) {
        errors["description"] = $.t("commonMessages.emptyMessage");
      }
      for (const errorField in errors) {
        // revert invalid attribute of Task model
        this.task.set(errorField, this.task.previous(errorField));
        // set error message
        this.view.setErrorMessage(errorField, errors[errorField]);
      }
      return _.isEmpty(errors);
    },
    _onChangePriority: function (priorityValue) {
      this.updateDueDate(priorityValue, this.view.getStartDate());
    },
    _onChangeStartDate: function (startDate) {
      this.updateDueDate(this.view.getPriority(), startDate);
    },
    _onCreateFromTemplate: function (templateId) {
      Messenger.vent.trigger("task:create:fromTemplate", {
        intentId: this.task.get("intentId"),
        intentName: this.task.get("intentName"),
        templateId: templateId,
      });
    },
    _onShow: function () {
      this.taskUpload.show(this.task, this.task.uploads());
      this.taskSchedule.show(this.task);
      const intentId = this.task.get("intentId");
      if (intentId) {
        this.view.setExistingTopicId(intentId);
      }
    },
    updateDueDate: function (priorityValue, startDate) {
      const priority = this.task.priorities.get(priorityValue);
      const days = priority.get("days");
      // Since we are not displaying the date, only using moment for calculations, then DO NOT USE moment.tz
      const startDateMoment = startDate ? moment.utc(startDate) : moment.utc();
      let dueDateMoment;
      if (days <= 0) {
        dueDateMoment = startDateMoment;
      } else {
        dueDateMoment = startDateMoment.add(days, "days");
      }
      const dueDate = dueDateMoment.toDate();
      this.view.setDueDate(dueDate);
    },
  });
});
